import { AuthContext, ProfileContext } from "../../Context";
import React, { useContext } from "react";

interface PageHeaderProps {
  title: string;
  src: string;
}

const PageHeader = (props: PageHeaderProps) => {
  const { token } = useContext(AuthContext);
  const { profile } = useContext(ProfileContext);

  // ========================================================================

  return (
    <section
      className={`${
        token ? (profile.personalVerification ? "pt-3" : "pt-0") : "pt-3"
      } pb-3`}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="border d-flex justify-content-center align-items-center bg-dark-overlay-9 position-relative text-center rounded-3 overflow-hidden"
              style={{ height: 110 }}
            >
              <img
                src={props.src}
                className="position-absolute w-100 opacity-50 "
              />
              <h1 className="z-index-10 text-white">{props.title}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
